
import { Link } from "react-router-dom";
import { useEffect, useState } from "react"
import { MdNavigateBefore } from "react-icons/md";

import { MdOutlineNavigateNext } from "react-icons/md";


export default function DemoCreatedTokens({ token }) {
  const [flash,setFlash] = useState(false)

useEffect(()=>{
  setFlash(true)
  const time = setTimeout(()=>setFlash(false),200)
  return()=>clearTimeout(time)
},[token])

  return (

    <div className={` max-w-[100%]  space-y-3 overflow-x-scroll `}>
      <h1 className="px-1 text-neutral-400 border-b border-yellow-500/10 rounded ">New Created Tokens</h1>

     { token && <table className="  rounded-lg  w-max    ">
        <thead className="bg-neutral-900">

          <tr className="text-yellow-600 text-left font-semibold capitalize text-xs rounded-lg ">
            <th className="p-3 text-xs">Name</th>
            <th className="p-3 text-xs">mint</th>
            <th className="p-3 text-xs">MC</th>
            <th className="p-3 text-xs">Owner Tokens</th>
          </tr>
        </thead>

        <tbody >


       
              { 
              token &&
               <tr className={`text-neutral-300  ${flash && 'bg-green-500/40'} border-b border-neutral-800  hover:bg-neutral-400/10 transition-all duration-400 h-14 `} >
                  <td className="p-3 text-xs text-yellow-500 hover:text-pink-500 truncate w-10">
                    <Link target="_blank" to={`https://pump.fun/coin/${token?.mint}`} >
                      <p className="w-40 truncate ">

                        {token?.name || 'noname'}
                      </p>
                    </Link>
                  </td>
                  <td className="p-3 text-xs w-max ">{token?.mint}</td>
                  <td className="p-3 text-xs w-max ">{token?.marketCapSol?.toFixed()} SOL</td>
                  <td className="p-1 text-xs  "> <p className="p-1 text-xs   border border-neutral-800 w-max rounded-lg px-5 bg-neutral-800 ">{ token?.initialBuy?.toFixed()} - {((token?.initialBuy?.toFixed()/1e9)*100).toFixed()}% </p>   </td>
                
                </tr>
                }
        
        </tbody >
      </table>
        }

    

    </div>


  )


}